import { ActionIcon, Modal } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import { useState } from "react";
import CustomInput from "../CustomInput/CustomInput";
import { ICell } from "../Cell/Cell.types";
import { useInputProps } from "../hooks/useInputProps";
import dayjs from "dayjs";
import { toMantineDateString } from "src/utils/mantineDates";

interface DateOrTextInputProps extends ICell {
  uuid: string;
  rowIndex?: number;
  colIndex?: number;
}

const DateOrTextInput = ({
  uuid,
  cell,
  tag,
  rowIndex,
  colIndex,
  ...props
}: DateOrTextInputProps & { cell: any }) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const { onChange, value } = useInputProps(uuid, cell.value ?? "");

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          width: "100%",
        }}>
        <CustomInput
          {...cell}
          tag={tag}
          id={uuid}
          domId={cell.id ?? ""}
          rowIdx={rowIndex}
          colIndex={colIndex}
          readonly={tag?.startsWith("OnyxPercTotal") ? true : cell.readonly}
          sectionIndex={cell.sectionIndex}
          style={{ flex: 1 }}
        />
        <ActionIcon
          variant="light"
          color="blue"
          onClick={() => {
            setDatePickerOpen(true);
          }}
          title="Open calendar">
          <IconCalendar size={18} />
        </ActionIcon>
      </div>
      <Modal
        opened={datePickerOpen}
        onClose={() => setDatePickerOpen(false)}
        title="Select Date"
        size="auto"
        centered>
        <DatePicker
          value={toMantineDateString(value)}
          onChange={date => {
            if (date) {
              onChange(dayjs(date).format("DD MMM YYYY"));
              setDatePickerOpen(false);
            }
          }}
        />
      </Modal>
    </>
  );
};

export default DateOrTextInput;
